const FIELD_COMPONENT_TYPES = Object.freeze([
    'AgeField',
    'AutocompleteField',
    'CampusPlaceField',
    'CheckboxField',
    'ChoiceWithSpecifyField',
    'ColorField',
    'DateField',
    'DateTimeField',
    'EmojiField',
    'FileField',
    'InterestsInputField',
    'MultiSelectField',
    'PlaceField',
    'RadioField',
    'SelectField',
    'SelectWithSpecifyField',
    'SliderWithOptOutField',
    'SwitchField',
    'TextAlertsPreferenceField',
    'TextField',
    'TextareaField'
]);

exports.FIELD_COMPONENT_TYPES = FIELD_COMPONENT_TYPES;
exports.FIELD_COMPONENT_TYPE_SET = new Set(FIELD_COMPONENT_TYPES);
exports.isFieldComponentType = (type) => exports.FIELD_COMPONENT_TYPE_SET.has(type);
